import request from '@/router/axios';
//通过类型查询管理人员列表
export const searchManagerList = (data) => {
  return request({
    url: '/svolt-ess-boss-service/manager/searchManagerList',
    method: 'get',
    params: data
  })
}

//查询用户管理负责项目详情
export const searchManagerProjectDetail = (data) => {
  return request({
    url: '/svolt-ess-boss-service/manager/searchManagerProjectDetail',
    method: 'post',
    data: data
  })
}

//添加用户项目管理员
export const addUserProjectManager = (data) => {
  return request({
    url: '/svolt-ess-boss-service/manager/addUserProjectManager',
    method: 'post',
    data: data
  })
}

//删除用户管理的
export const deleteByUser = (data) => {
  return request({
    url: '/svolt-ess-boss-service/manager/deleteByUser',
    method: 'post',
    data: data
  })
}

//查询全部用户
export const searchAllUser = (data) => {
  return request({
    url: '/svolt-ess-boss-service/user/searchAllUser',
    method: 'post',
    data: data
  })
}


export default{
  searchManagerList,
  searchManagerProjectDetail,
  addUserProjectManager,
  deleteByUser,
  searchAllUser
}



// WEBPACK FOOTER //
// ./src/api/worker.js